import React, { useEffect, useState } from "react";
import Header2 from "../Header2/header2";
import Footer from "../Footer/footer";
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from "@/config/serverApiConfig";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Badge } from "antd";
import Moment from 'moment';
import moment from "moment";
const RequestHistory = () => {
  Moment.locale('en');
  let [categories, setCategories] = useState([]);




  const history = useHistory();
  if (localStorage.getItem("token") === undefined || localStorage.getItem("token") === null) {
    history.push('/login');
  }
  let [user, setUser] = useState(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  const [data, setData] = useState([])
  let [categoryOne, setCategoryOne] = useState([]);
  let [categoryTwo, setCategoryTwo] = useState([]);
  let [categoryThree, setCategoryThree] = useState([]);
  let [categoryFour, setCategoryFour] = useState([]);
  let config = {

    headers: {
      'x-access-token': `${token}`
    }
  }
  useEffect(() => {
    axios.post(`${API_BASE_URL}user/getRequestHistory`, {}, config)
      .then(res => {
        setData(res.data.data)
        // setCategoryOne(res.data.categoryOne.name)
        // setCategoryTwo(res.data.categoryTwo.name)
        // setCategoryThree(res.data.categoryThree.name)

      })
      .catch(err => {
      
      });
  }, []);








  return (
    <>
      <Header2 />
      <Container className="request-history-sec pb-5 min-height-g">
        <Breadcrumb className="pt-5 pb-4">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>REQUEST HISTORY</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <ListGroup>
            {data.map((item, i) => {
              return (
                <ListGroup.Item className="mb-3 py-4 px-4" key={i}>
                  <span className="">
                    <span className="cata-icon"></span>
                    <span className="cata-name">Category</span>
                    <span className="arrow-icon">{'>'}</span>
                    <span className="cata-item">{item.category_id_one && item.category_id_one.name ? "Request For ("+item.category_id_one.name+")" : ''}  |   {item.category_id_two && item.category_id_two.name ? "Request For ("+item.category_id_two.name+")" : ''}   |   {item.category_id_three && item.category_id_three.name ? "Request For ("+item.category_id_three.name+")" : ''}</span>
                  </span>
                  <span className="cata-date">Request On: {(item.created) ? moment(item.created).format("DD-MMM-YYYY") : ""}</span>
                </ListGroup.Item>
              )
            })}
          </ListGroup>
        </Row>
      </Container>
      <Footer />

    </>
  )
}


export default RequestHistory;